import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { RouteApplicationStartupResolveService } from '../../core/route-application-startup-resolve.service';
import { InvoiceShellComponent } from './invoice-shell/invoice-shell.component';
import { InvoiceListComponent } from './invoice-list/invoice-list.component';
import { InvoiceLookupResolveService } from './shared/services/invoice-lookup-resolve.service';

const invoicesRoutes: Routes = [
  // {
  //     path: 'invoices',
  //     component: InvoiceShellComponent,
  //     resolve:{
  //         appData: RouteApplicationStartupResolveService,
  //         lookupData: InvoiceLookupResolveService
  //     },
  //     children:[
  //         {
  //             path: '',
  //             redirectTo: 'list',
  //             pathMatch: 'full'
  //         },
  //         {
  //             path: 'list',
  //             component: InvoiceListComponent
  //         },
  //         {
  //             path: 'list/:code',
  //             component: InvoiceListComponent
  //         }
  //     ]
  // }
];

@NgModule({
  imports: [CommonModule, RouterModule.forChild(invoicesRoutes)],
  exports: [RouterModule],
  declarations: [],
})
export class invoicesRoutingModule {}
